import { SET_SESSION_ID, CLEAR_SESSION_ID } from "../actions/types";

const initialState = null;

function sessionReducer(session = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_SESSION_ID:
            return payload;

        case CLEAR_SESSION_ID:
            return null;

        default:
            return session;
    }
}

export default sessionReducer;